import { Text, Button, Stack, Image, Group, Textarea } from "@mantine/core";

export default function FeedbackPage({
	feedbackText,
	setFeedbackText,
	goNext,
	goBack,
}) {
	return (
		<Stack
			px="4.7vw"
			pt="24.42vw"
			pb="11.63vw"
			align="center"
			justify="space-between"
			h="100vh"
		>
			<Group w="100%" px="3.54vw" justify="center">
				<Image
					src={window.assetUrl("/images/liff/questionnaire-page/logo.png")}
					alt="Tory Burch"
					w="58%"
				/>
			</Group>

			<Stack align="center" gap="lg" w="100%">
				<Text align="center" size="3.76vw" lh="1.4">
					請告訴我們您選擇上題答案的原因？
				</Text>

				<Textarea
					w="100%"
					size="md"
					value={feedbackText}
					onChange={(e) => setFeedbackText(e.target.value)}
					styles={{
						input: {
							height: "51.16vw",
						},
					}}
				/>
			</Stack>

			<Stack w="100%" px="3.54vw">
				<Button
					fullWidth
					radius="xl"
					size="lg"
					color="black"
					style={{
						border: "2px solid #DDDDDD",
					}}
					onClick={goNext}
				>
					送出
				</Button>
				<Button
					fullWidth
					variant="transparent"
					radius="xl"
					size="lg"
					color="black"
					onClick={goBack}
				>
					上一題
				</Button>
			</Stack>
		</Stack>
	);
}
